module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/core-js/library/modules/_add-to-unscopables.js
// module id = 402
// module chunks = 0